import { render, staticRenderFns } from "./Pds.vue?vue&type=template&id=46ed1282&scoped=true"
import script from "./Pds.vue?vue&type=script&lang=js"
export * from "./Pds.vue?vue&type=script&lang=js"
import style0 from "./Pds.vue?vue&type=style&index=0&id=46ed1282&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed1282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ed1282')) {
      api.createRecord('46ed1282', component.options)
    } else {
      api.reload('46ed1282', component.options)
    }
    module.hot.accept("./Pds.vue?vue&type=template&id=46ed1282&scoped=true", function () {
      api.rerender('46ed1282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/Pds.vue"
export default component.exports